






























import Vue from 'vue'
import ConfirmDialog from '@/components/elements/ConfirmDialog.vue'
import { ActionInterface, LinkWithTextElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'LinkWithTextEl',

  data: () => ({
    showPopup: false
  }),

  components: { ConfirmDialog },

  methods: {
    handleActionClick (action: ActionInterface): void {
      if (action.uri !== undefined) {
        this.getView(action.view, action.content || action.uri, null, action.jumpOnCloseUri)
      }
    }
  },

  computed: {
    hasPopup (): boolean {
      return !!Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'confirmDialog')
    }
  },

  props: {
    templateItemData: {
      type: Object as () => LinkWithTextElInterface,
      required: true
    }
  }
})
